<template lang="pug">
  label.file-select
    .select-button
      span(v-if="value") Файл: {{ value.name | ellipsis({max: 15, postfix: '...'}) }}
      span(v-else) Выберите файл
    input(
      type="file"
      @change="handleFileChange"
    )
</template>

<script>
export default {
  name: 'FileSelect',

  data() {
    return {
      uploadedFile: null
    };
  },

  props: {
    value: File
  },

  methods: {
    handleFileChange(e) {
      this.$emit('input', e.target.files[0]);
      this.$emit('fileInput', e.target.files[0]);
    },

    reset() {
      this.$forceUpdate();
    }
  },

  filters: {
    ellipsis(value, options) {
      const re = /(?:\.([^.]+))?$/;
      const ext = re.exec(value)[1];
      return value.length > options.max
        ? value.substring(0, options.max) +
            options.postfix +
            value.slice(-ext.length - 2, -ext.length - 1) +
            '.' +
            ext
        : value;
    }
  }
};
</script>

<style lang="scss" scoped>
@import '~@/assets/scss/core.scss';

.file-select {
  display: inline;
}

.file-select > .select-button {
  @extend %button;
  margin-top: 0;
}

.file-select > input[type='file'] {
  display: none;
}
</style>
